// Module
var code = "<p>You&#39;ll know you&#39;ll receive a Monthly Direct Debit Statement if &quot;MONTHLY Direct Debit STATEMENT&quot; appears in the upper left-hand corner.</p> ";
// Exports
export default code;